import React from "react";
import "../styles/layouts/navbar.scss";

export default function NavBar({ showFilters, showMap, showInfo, mapWarning }) {
  return (
    <div className="navbarWrapper">
      <div className="navbar">
        <nav>
          <button onClick={showFilters()}>FILTROS</button>
          <button onClick={showMap()}>
            {mapWarning ? (
              <div className="mapAlert" style={{ display: "flex" }}>
                MAPA
              </div>
            ) : (
              <div>MAPA</div>
            )}
          </button>
          <button onClick={showInfo()}>INFO</button>
        </nav>
      </div>
    </div>
  );
}
